import React, { useState } from 'react';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import CollapsibleUI from '../../../../components/UI/CollapsibleUI';
import { Button, Input } from '../../../../components/UI/ComponentsUI';
import { onValueChange, validateInputsRequired } from '../../../../utils/handleChangeHooks';

const FormPartNumberItem = (props) => {
    const [editMode, setEditMode] = useState(false)
    const [editPartnumber, setEditPartnumber] = useState({})

    const onChange = (event) => {
        onValueChange(event, editPartnumber, setEditPartnumber);
    };

    const save = () => {
        setEditMode(false)
        setEditPartnumber({})
        props.editPartnumber(editPartnumber)
    };

    return (
        <div style={{ marginTop: '0px', padding: '0px' }}>
            {props.data?.map((item, index) => {
                return (
                    <div key={`${item.partNumberCode}-${index}`} className='row' style={{ padding: '0px' }}>
                        <div className="no-padding col s10">
                            <CollapsibleUI
                                close="true"
                                simple="true"
                                id={`filterPartNumberDeem-${item.partNumberCode}-${index}`}
                                header={`${item?.partNumberCode} - ${item?.partNumberDescription}`}
                                body={
                                    <div id="formInputPartNumberEdit" style={{ paddingBlockEnd: '1px' }}>
                                        <div className="row" style={{ marginBottom: 0 }}>
                                            <>
                                                <div className="input-field no-padding col s5">
                                                    <Input
                                                        disabled
                                                        value={item?.mdr || ""}
                                                        type="text"
                                                        label="MDR Origem"
                                                        id="mdr"
                                                        name='mdr'
                                                    />
                                                </div>
                                                <div className="input-field no-padding col s6">
                                                    <Input
                                                        defaultValue={item.deem}
                                                        type="text"
                                                        label={props.deem ? "Nº DEEM" : "MDR Real"}
                                                        id="deem"
                                                        name='deem'
                                                        onChange={onChange}
                                                        disabled={!editMode}
                                                    />
                                                </div>
                                                {
                                                    !props.deem && <div className="input-field no-padding col s12">
                                                        <Input
                                                            defaultValue={item.sqpNew}
                                                            type="text"
                                                            label="SQP Novo"
                                                            id="sqpNew"
                                                            name='sqpNew'
                                                            onChange={onChange}
                                                            disabled={!editMode}
                                                        />
                                                    </div>
                                                }
                                                <div className="input-field no-padding col s5">
                                                    <Input
                                                        disabled
                                                        value={item.declaredQuantity || ""}
                                                        type="text"
                                                        id="accoutingQuantity"
                                                        name='accoutingQuantity'
                                                        label="Qtd. Declarada"
                                                    />
                                                </div>
                                                <div className="input-field no-padding col s6">
                                                    <Input
                                                        required
                                                        type="number"
                                                        label="Qtd. Recebida"
                                                        id="receivedQuantity"
                                                        name="receivedQuantity"
                                                        onChange={onChange}
                                                        onBlur={onChange}
                                                        defaultValue={item.receivedQuantity}
                                                        disabled={!editMode}
                                                    />
                                                </div>
                                                <div className="input-field no-padding col s5">
                                                    <Input
                                                        disabled
                                                        value={item.declaredLabelQuantity}
                                                        id="qmeCalc"
                                                        name='qmeCalc'
                                                        label="Volume declarado"
                                                    />
                                                </div>
                                                <div className="input-field no-padding col s6">
                                                    <Input
                                                        required
                                                        defaultValue={item.receivedLabelQuantity || ""}
                                                        type="number"
                                                        label="Volume recebido"
                                                        id="receivedLabelQuantity"
                                                        name='receivedLabelQuantity'
                                                        onChange={onChange}
                                                        disabled={!editMode}
                                                    />
                                                </div>
                                                {!editMode && <Button full="true" text="Editar" onClick={() => {
                                                    setEditPartnumber(item)
                                                    setEditMode(true)
                                                }} />
                                                }
                                                {editMode && <Button full="true" text="Salvar" onClick={() => {
                                                    if (validateInputsRequired('formInputPartNumberEdit')) {
                                                        save()
                                                    }
                                                }} />
                                                }
                                            </>
                                        </div>
                                    </div>
                                }
                            />

                        </div>
                        <div className="padding col s2" style={{ paddingTop: '10px' }}>
                            <Button text="x" style={{ backgroundColor: '#d95454' }} onClick={() => props.removeItem(item)} />
                        </div>
                    </div>
                )
            })
            }
        </div>

    );
}

export default withRouter((withTranslation()(FormPartNumberItem)));
